import {
  FETCH_COLLECTIONS_REQUEST,
  FETCH_COLLECTION_REQUEST,
  RECEIVE_COLLECTION,
  RECEIVE_COLLECTIONS,
  RECEIVE_COLLECTIONS_ERROR,
  RECEIVE_COLLECTION_ERROR,
} from 'redux/constants/ActionTypes'

import { createApiAction } from './ApiActions'

// API actions
export const fetchCollections = (currentLocale) => {
  return createApiAction({
    endpoint: `/${currentLocale}/collections/`,
    types: [
      FETCH_COLLECTIONS_REQUEST,
      RECEIVE_COLLECTIONS,
      RECEIVE_COLLECTIONS_ERROR,
    ],
    currentLocale,
  })
}

export const fetchCollection = (currentLocale, slug, authToken, session) => {
  return createApiAction({
    endpoint: `/${currentLocale}/collections/${slug}?session_progress=${session}`,
    types: [
      FETCH_COLLECTION_REQUEST,
      RECEIVE_COLLECTION,
      RECEIVE_COLLECTION_ERROR,
    ],
    currentLocale,
    authToken,
    slug,
  })
}
